import { useTranslation } from 'react-i18next';

import type { Domain } from '@feathr/blackbox';
import { toast } from '@feathr/components';

/** Restarts a domain's verification, then reloads it so its statuses update without waiting for a poll. */
function useRefreshDomain(domain: Domain): () => Promise<void> {
  const { t } = useTranslation();

  async function refreshDomain(): Promise<void> {
    try {
      await domain.refresh();
    } catch {
      toast(t("Couldn't refresh domain. Contact support."), { type: 'error' });
      return;
    }
    await domain.reload();
    toast(t('Restarted domain verification.'), { type: 'success' });
  }

  return refreshDomain;
}

export default useRefreshDomain;
